(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giftroo-banner"] && !Shopify.designMode) return;
  try {
    
  /* Swaps the heading word on a fixed timer, non-stop.
     - starts as soon as the banner loads and never pauses or resets
       (not on hover, not when the slide changes, not when the tab is in the background)
     - for visitors who prefer reduced motion the words still change, just without the pop animation */
  if (!customElements.get('gr-word-rotator')) {
    customElements.define('gr-word-rotator', class extends HTMLElement {
      connectedCallback() {
        this.words = Array.from(this.querySelectorAll('.gr-word'));
        if (this.words.length < 2) return;

        this.index = 0;
        this.interval = Math.max(2, parseFloat(this.getAttribute('interval')) || 5) * 1000;
        this.timer = setInterval(() => {
          this.show((this.index + 1) % this.words.length);
        }, this.interval);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      show(i) {
        const previous = this.words[this.index];
        const next = this.words[i];

        if (previous !== next) {
          previous.classList.remove('is-active');
          previous.classList.add('is-leaving');
          setTimeout(() => previous.classList.remove('is-leaving'), 320);
        }

        next.classList.remove('is-active', 'is-leaving');
        void next.offsetWidth; /* restart the entrance animation */
        next.classList.add('is-active');
        this.index = i;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
